import { render, staticRenderFns } from "./DocumentSelectionPicker.vue?vue&type=template&id=70290287&"
import script from "./DocumentSelectionPicker.vue?vue&type=script&lang=ts&"
export * from "./DocumentSelectionPicker.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports